const axios = require('axios')


//------------------------------------------------------------
//------------------------------------------------------------
//------------------------------------------------------------

// const { download_docx_esterno } = require('../Funzioni_comuni')

const download_docx_esterno1 = (documento, progetto) => {
  const cognome = progetto.id_alunno.cognome
  const nome = progetto.id_alunno.nome
  let indirizzo
  if (documento === 'progetto') {
      indirizzo = 'Progetto_docx'
  }
  if (documento === 'rapporto') {
      indirizzo = 'Rapporto_docx'
  }

  console.log('indirizzo ' + indirizzo)
  
  axios.get('/transfer_s3/progetto_docx_ottieni_url/' + indirizzo + '/' + cognome + '/' + nome )
      .then((res) => {
          console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
          console.log(res.data)
          const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')

          if (newWindow) newWindow.opener = null
         
//                return res.data
      }).catch((error) => {
          console.log('ottieni_url url errore')
          console.log(error)
      });
};
exports.download_docx_esterno1 = download_docx_esterno1;

